import { render, staticRenderFns } from "./serviceAdvice.vue?vue&type=template&id=5cb5ff30&"
import script from "./serviceAdvice.vue?vue&type=script&lang=js&"
export * from "./serviceAdvice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports